<template>
  <div>
    <v-card class="mb-3">
      <v-card-title><h4>Получаемые доходи филиалов</h4></v-card-title>
      <v-card-text>
        <validation-observer tag="div" v-slot="{handleSubmit}">
          <div class="row flex-md-row flex-column">
            <div class="pa-2">
              <custom-autocomplete
                label="Филиалы"
                multiple
                hide-details
                rules="required"
                hide="details"
                prepend-item
                customSelection
                v-model="selectedBranches"
                :items="branches">
                <template v-slot:selection="{item, index}">
                  <v-chip outlined v-if="index === 0">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span
                    v-if="index === 1"
                    class="grey--text caption"
                  >(+{{ selectedBranches.length - 1 }})</span>
                </template>
                <template #prepend:item>
                  <v-list-item v-ripple @click="isSelectedAllBranches ? resetAll() : selectAll()">
                    <v-list-item-content>
                      <v-list-item-title>{{
                          isSelectedAllBranches ? 'Убрать все' : 'Выбрать все'
                        }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </custom-autocomplete>
            </div>
            <div class="pa-2">
              <custom-date-picker
                hide="details"
                rules="required"
                v-model="from"
                label="От"
              />
            </div>
            <div class="pa-2">
              <custom-date-picker
                rules="required"
                hide="details"
                label="До"
                v-model="to"
              />
            </div>
            <div class="pa-2">

              <v-btn :width="$vuetify.breakpoint.mdAndDown ? '100%' : null" small height="38" color="primary"
                     @click="handleSubmit(getMkoReport)">
                Получить данные
              </v-btn>
            </div>
            <div class="pa-2">
              <download-excel-report-list
                :checkValidation="handleSubmit"
                :filter="{from, to, mkos: selectedBranches}"
              />
            </div>
          </div>
        </validation-observer>

      </v-card-text>
    </v-card>

    <v-card>
      <v-card-text>
        <v-simple-table
          class="table-wth-border">
          <thead class="table-header">
          <tr>
            <th rowspan="2" class="text-center">№</th>
            <th rowspan="2" class="text-center">Лого</th>
            <th rowspan="2" class="text-center">Филиал</th>
            <th rowspan="2" class="text-center">Название фирмы</th>
            <th rowspan="2" class="text-center">ИНН</th>
            <th rowspan="2" class="text-center">Номер документа</th>
            <th rowspan="2" class="text-center">Телефон</th>
            <th rowspan="2" class="text-center">Дата создание</th>
            <th rowspan="2" class="text-center">Paymo терминал</th>
            <th colspan="3" class="text-center">КАТМ</th>
            <th colspan="3" class="text-center">Активные кредиты (С картой)</th>
            <th colspan="3" class="text-center">Активные кредиты (Без карты)</th>
            <th colspan="3" class="text-center">Paymo - скоринг</th>
            <th colspan="3" class="text-center">НАЛОГ - сведения о доходах</th>
            <th colspan="3" class="text-center">НАЛОГ - Налоговая задолженность</th>
            <th colspan="3" class="text-center">НАЛОГ - Информация по физическим лицам</th>
            <th colspan="3" class="text-center">НАЛОГ - Сведение об имуществе</th>
            <th colspan="3" class="text-center">НАЛОГ - Сведение о сданной в аренду имущества</th>
            <th colspan="5" class="text-center">Транзакции</th>
            <th rowspan="2" class="text-center" style="min-width: 150px">Общая сумма</th>
          </tr>
          <tr>
            <th class="text-center" style="min-width: 150px">Кредитная истоия (кол-во)</th>
            <th class="text-center" style="min-width: 150px">Сведения о доходах (кол-во)</th>
            <th class="text-center" style="min-width: 150px">Пенсия и пособия (кол-во)</th>
            <template v-for="n in 8">
              <th class="text-center" style="min-width: 74px">Кол-во</th>
              <th class="text-center">Цена</th>
              <th class="text-center amount-td ">Сумма</th>
            </template>
            <th class="text-center">Кол-во</th>
            <th class="text-center" style="min-width: 150px">Сумма</th>
            <th class="text-center" style="min-width: 150px">Нал</th>
            <th class="text-center" style="min-width: 150px">Paymo</th>
            <th class="text-center" style="min-width: 150px">Uzcard</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in mkos" :key="item.mko_id">
            <td>{{ item.mko_id }}</td>
            <td>
              <v-avatar>
                <img style="object-fit: contain" :src="item.mko_logo || noImage" alt="">
              </v-avatar>
            </td>
            <td>{{ item.mko_name }}</td>
            <td><span class="white-space-no-wrap">{{ item.company_name }}</span></td>
            <td>{{ item.inn }}</td>
            <td>{{ item.document_number }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ item.created_at |parseDate }}</td>
            <td>{{ item.paymo }}</td>
            <td>{{ item.katm_info['count'] }}</td>
            <td>{{ item.katm_salary['count'] }}</td>
            <td>{{ item.katm_pension['count'] }}</td>
            <td>{{ item.credits['count'] }}</td>
            <td>{{ item.credits['price'] }}</td>
            <td>{{ item.credits['amount'] |money }}</td>
            <td>{{ item.credits_cash['count'] }}</td>
            <td>{{ item.credits_cash['price'] }}</td>
            <td>{{ item.credits_cash['amount'] |money }}</td>
            <td>{{ item.scoring['count'] }}</td>
            <td>{{ item.scoring['price'] }}</td>
            <td>{{ item.scoring['amount'] |money }}</td>
            <td>{{ item.tax_salary['count'] }}</td>
            <td>{{ item.tax_salary['price'] }}</td>
            <td>{{ item.tax_salary['amount'] |money }}</td>
            <td>{{ item.tax_debt['count'] }}</td>
            <td>{{ item.tax_debt['price'] }}</td>
            <td>{{ item.tax_debt['amount'] |money }}</td>
            <td>{{ item.tax_info['count'] }}</td>
            <td>{{ item.tax_info['price'] }}</td>
            <td>{{ item.tax_info['amount'] |money }}</td>
            <td>{{ item.tax_property['count'] }}</td>
            <td>{{ item.tax_property['price'] }}</td>
            <td>{{ item.tax_property['amount'] |money }}</td>
            <td>{{ item.tax_load['count'] }}</td>
            <td>{{ item.tax_load['price'] }}</td>
            <td>{{ item.tax_load['amount'] |money }}</td>
            <td>{{ item.transactions['count'] }}</td>
            <td>{{ item.transactions['amount'] |money }}</td>
            <td>{{ item.transactions['cash'] |money }}</td>
            <td>{{ item.transactions['paymo'] |money }}</td>
            <td>{{ item.transactions['myuzcard'] |money }}</td>
            <td>{{ item.total |money }}</td>
          </tr>
          <tr style="font-size: 1.2rem" class="total-row" v-if="totalRowData">
            <td>{{ totalRowData.mko_id }}</td>
            <td></td>
            <td><span class="white-space-no-wrap">{{ totalRowData.mko_name }}</span></td>
            <td>{{ totalRowData.company_name }}</td>
            <td>{{ totalRowData.inn }}</td>
            <td>{{ totalRowData.document_number }}</td>
            <td>{{ totalRowData.phone }}</td>
            <td>{{ totalRowData.created_at }}</td>
            <td>{{ totalRowData.created_at }}</td>
            <td>{{ totalRowData.katm_info['count'] }}</td>
            <td>{{ totalRowData.katm_salary['count'] }}</td>
            <td>{{ totalRowData.katm_pension['count'] }}</td>
            <td>{{ totalRowData.credits['count'] }}</td>
            <td>{{ totalRowData.credits['price'] }}</td>
            <td>{{ totalRowData.credits['amount'] |money }}</td>
            <td>{{ totalRowData.credits_cash['count'] }}</td>
            <td>{{ totalRowData.credits_cash['price'] }}</td>
            <td>{{ totalRowData.credits_cash['amount'] |money }}</td>
            <td>{{ totalRowData.scoring['count'] }}</td>
            <td>{{ totalRowData.scoring['price'] }}</td>
            <td>{{ totalRowData.scoring['amount'] |money }}</td>
            <td>{{ totalRowData.tax_salary['count'] }}</td>
            <td>{{ totalRowData.tax_salary['price'] }}</td>
            <td>{{ totalRowData.tax_salary['amount'] |money }}</td>
            <td>{{ totalRowData.tax_debt['count'] }}</td>
            <td>{{ totalRowData.tax_debt['price'] }}</td>
            <td>{{ totalRowData.tax_debt['amount'] |money }}</td>
            <td>{{ totalRowData.tax_info['count'] }}</td>
            <td>{{ totalRowData.tax_info['price'] }}</td>
            <td>{{ totalRowData.tax_info['amount'] |money }}</td>
            <td>{{ totalRowData.tax_property['count'] }}</td>
            <td>{{ totalRowData.tax_property['price'] }}</td>
            <td>{{ totalRowData.tax_property['amount'] |money }}</td>
            <td>{{ totalRowData.tax_load['count'] }}</td>
            <td>{{ totalRowData.tax_load['price'] }}</td>
            <td>{{ totalRowData.tax_load['amount'] |money }}</td>
            <td>{{ totalRowData.transactions['count'] }}</td>
            <td>{{ totalRowData.transactions['amount'] |money }}</td>
            <td>{{ totalRowData.transactions['cash'] |money }}</td>
            <td>{{ totalRowData.transactions['paymo'] |money }}</td>
            <td>{{ totalRowData.transactions['myuzcard'] |money }}</td>
            <td>{{ totalRowData.total |money }}</td>
          </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>


  </div>
</template>

<script>
import DownloadExcelReportList from "@/components/report/DowloadExcelReportList";
import Template from "../../../components/ui/crud/template";

export default {
  components: {Template, DownloadExcelReportList},
  data() {
    return {
      mkos: [],
      branches: [],
      selectedBranches: [],
      from: null,
      to: null,
      options: {},
      headers: [],
      totalRowData: null
    }
  },
  computed: {
    isSelectedAllBranches() {
      return this.branches.length === this.selectedBranches.length
    },
    noImage() {
      return require('../../../assets/images/no-image.png')
    }
  },
  methods: {
    async getMkoReport() {
      const queryData = {
        mkos: this.selectedBranches,
        from: this.from,
        to: this.to
      }
      this.$showLoading()
      try {
        const {data: {data}} = await this.$http.get('admin/calculate/report', {
          params: queryData
        })
        this.totalRowData = data.pop()
        this.mkos = data
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    selectAll() {
      this.selectedBranches = this.branches.map(i => i.id)
    },
    resetAll() {
      this.selectedBranches = [];
    }
  },
  async mounted() {
    try {
      this.branches = await this.$store.dispatch('getMkos')
    } catch (e) {
      this.$setResponseError({error: e})
    }
  }
}
</script>


<style lang="scss">
.total-row {
  td {
    font-size: .9rem !important;
    font-weight: bold;
  }
}

.amount-td {
  min-width: 115px;
}

.table-header {
  th {
    text-align: center;
    border: 0.1px solid #999;
  }
}
</style>
